module.exports = __webpack_public_path__ + "static/media/mcitp.e1a0eaaa.png";